import request from "@/utils/request"

// 获取租户详情
export const getTenantDetail = function(tenant_id) {    
  return request('get', `/api/tenant/detail/${tenant_id}`)
}
